export type { MerchPageProps } from "./merch-page";
export { MerchPage } from "./merch-page";
